import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import { SpeciesTestTypesQueryResult, speciesTestTypesQuery } from './speciesQuery';

const speciesGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        speciesTestTypes: builder.query<SpeciesTestTypesQueryResult, { projectId: string }>({
            query: params => ({
                body: speciesTestTypesQuery,
                variables: params,
            }),
        }),
    }),
});

export const { useSpeciesTestTypesQuery } = speciesGraphSlice;
